<template>
  <div id='' style='' class='gPageBorder'>
    <el-form class='gForm' label-position="right" ref="form" :rules='rules' label-width="12.5%" :model='form'>
      <el-form-item :label="$t('lin_global.risk_name')" prop='name'>
        <el-input v-model="form.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('lin_global.fwqdizhi')" prop='addr'>
        <el-input v-model="form.addr" placeholder='exp: www.domain.com'></el-input>
      </el-form-item>
      <el-form-item :label="$t('lin_global.fwqduankou')" prop='port'>
        <el-input v-model="form.port" placeholder='exp: 0000'></el-input>
      </el-form-item>
      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' @click="save('form')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>
   
  </div>
</template> 

<style>
</style>

<script>
  export default{
    data () {
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
      return {
        cfid: -1,
        fatherList: [],
        form: {
          name: '',
          addr: '',
          port: ''
        },
        rules: {
          name: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          addr: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          port: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      getDetail () {
        // this.loading = 1        
        this.$syscfDetail(this.cfid, (res) => {      
          // this.loading = 0
          if (res.status == 200) {            
            this.fillData(res.data)
          } else {
            this.$message(res.message)
          }
        }, () => {
          
        })
      },
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g') 
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newform () {
        this.loading = 1
        var form = this.form
        this.$addSyscf(form.name, form.addr, form.port, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editform () {
        // var data = this.config.data
        // console.log(this.form)
        this.loading = 1
        var form = this.form
        this.$editSyscf(parseInt(this.cfid), form.name, form.addr, form.port, (res) => {
          this.loading = 0
          if (res.status == 200) {            
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        }) 
      },
      save (name) {
        // console.log(this.form)
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (this.cfid == -1) {
              this.newform()
            } else {
              this.editform()
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      fillData (data) {        
        this.form.name = data.configName
        this.form.addr = data.address
        this.form.port = data.port
      }
    },
    mounted () {
      this.cfid = this.$route.query.id
      
      if (this.cfid != -1) {
        this.getDetail()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?577221a2